import {Routes} from '@angular/router';
import {InitGuard} from './resolves/init.guard';
import {EditorInterfaceComponent} from './editor-interface/editor-interface/editor-interface.component';
import {ViewResolve} from './resolves/view-resolve.resolver';
import {QueryParamGuard} from './resolves/query-param.guard';
import {DiagramCanvasComponent} from './diagram-render/diagram-canvas/diagram-canvas.component';
import {NoUiResolve} from './resolves/noui.resolve';
import {CostRegistryResolver} from '@q9elements/ui-kit/common';

export const appRoutes: Routes = [
  {
    path: 'noui',
    resolve: {
      noui: NoUiResolve
    },
    component: DiagramCanvasComponent
  },
  {
    path: '404',
    loadComponent: () => import('./not-found/not-found.component').then(c => c.NotFoundComponent)
  },
  // Redirects for old application links:
  {
    path: ':id',
    redirectTo: 'diagram/:id',
    pathMatch: 'full'
  },
  {
    path: ':id/edit',
    redirectTo: 'diagram/:id',
    pathMatch: 'full'
  },
  // Main route
  {
    path: 'diagram',
    canActivateChild: [QueryParamGuard],
    resolve: {actionCosts: CostRegistryResolver},
    children: [
      {
        path: ':diagramId',
        runGuardsAndResolvers: 'always',
        canActivate: [InitGuard],
        canDeactivate: [ViewResolve],
        resolve: {viewResolve: ViewResolve},
        component: EditorInterfaceComponent
      }
    ]
  },
  {path: '**', redirectTo: '404'}
];
